// import React, { useEffect, useState } from "react";
// import logo from "../assets/logo.png";
// import leftimg from "../assets/creative_ux_illustration_tubik 1.png";
// import { login } from "../services/user.services";
// import { jwtDecode } from "jwt-decode";
// import { useDispatch, useSelector } from "react-redux";
// import { setUser } from "../state/reducers/userSlice";
// import { useLocation, useNavigate } from "react-router-dom";
// import toast from "react-hot-toast";

// const Login = () => {
//   const userrole = useSelector((state) => state.user.role);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const [form, setForm] = useState({
//     email: "",
//     password: "",
//   });

//   const handeChangeInput = (event) => {
//     setForm({ ...form, [event.target.name]: event.target.value });
//   };

//   const submitForm = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await login(form);
//       const decoded = jwtDecode(response.data.data.access);
//       const userdetails = {
//         email: decoded.email,
//         name: decoded.name,
//         role: decoded.role,
//         user_id: decoded.user_id,
//       };
//       const token = response.data.data.access;
//       const expirationTime = new Date().getTime() + 30 * 24 * 60 * 60 * 1000; // 30 days
//       localStorage.setItem("token", token);
//       localStorage.setItem("expires", expirationTime); // Set expiration time
//       dispatch(setUser(userdetails));
//     } catch (err) {
//       console.error(err);
//       toast.error("Login failed! Please check your credentials."); // Show error toast
//     }
//   };

//   const location = useLocation();
//   const from = location.state?.from || null;

//   useEffect(() => {
//     if (userrole) {
//       // Redirect to original path if available, else default
//       if (from) {
//         navigate(from, { replace: true });
//       } else if (userrole === "student") {
//         navigate("/student", { replace: true });
//       } else if (userrole === "admin" || userrole === "superadmin") {
//         navigate("/admin", { replace: true });
//       }
//     }
//   }, [userrole]);

//   return (
//     <>
//       <div className="flex items-center justify-center h-[100vh]">
//         <div className="flex items-center justify-center border-solid border-2 border-gray-200 shadow-lg">
//           {/* Left Side (Image/Illustration) */}
//           <div className="hidden md:flex md:w-1/2 h-full bg-yellow-200 justify-center items-center">
//             <img className="w-full h-full shadow-lg" src={leftimg} alt="" />
//           </div>

//           {/* Right Side (Login Form) */}
//           <div className="flex flex-col justify-center items-center md:w-1/2 w-full px-6 py-8">
//             <div className="max-w-md w-full">
//               <div className="flex justify-center mb-6">
//                 <img src={logo} alt="Logo" className="w-40 h-auto" />
//               </div>

//               <h2 className="text-center text-3xl font-bold text-gray-800">
//                 Welcome back 👋
//               </h2>
//               <p className="text-center text-gray-500 mb-8">
//                 Enter your credentials to access your account
//               </p>

//               <form className="space-y-4">
//                 <div>
//                   <input
//                     name="email"
//                     type="email"
//                     placeholder="Email ID"
//                     className="mt-1 px-3 py-2 border border-gray-300 w-full focus:outline-none focus:border-indigo-500"
//                     onChange={handeChangeInput}
//                   />
//                 </div>

//                 <div className="flex justify-end">
//                   {/* <a
//                     href="#"
//                     className="text-sm text-indigo-600 hover:text-indigo-500"
//                   >
//                     Forgot Password?
//                   </a> */}
//                 </div>
//                 <div>
//                   <input
//                     name="password"
//                     type="password"
//                     placeholder="Password"
//                     className="px-3 py-2 border border-gray-300 w-full focus:outline-none focus:border-indigo-500"
//                     onChange={handeChangeInput}
//                   />
//                 </div>

//                 <div>
//                   <button
//                     type="submit"
//                     className="w-[150px] bg-indigo-600 text-white flex mx-auto justify-center align-center py-2 px-4 hover:bg-indigo-700 focus:outline-none"
//                     onClick={submitForm}
//                   >
//                     Login
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Login;
import React, { useEffect, useState } from "react";
import logo from "../assets/logo.png";
import leftimg from "../assets/creative_ux_illustration_tubik 1.png";
import { login } from "../services/user.services";
import { jwtDecode } from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../state/reducers/userSlice";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import ForgetPassword from "./ForgetPassword";

const Login = () => {
  const userrole = useSelector((state) => state.user.role);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showForgetPassword, setShowForgetPassword] = useState(false);
  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const handeChangeInput = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const submitForm = async (e) => {
    e.preventDefault();
    try {
      const response = await login(form);
      const decoded = jwtDecode(response.data.data.access);
      const userdetails = {
        email: decoded.email,
        name: decoded.name,
        role: decoded.role,
        user_id: decoded.user_id,
      };
      const token = response.data.data.access;
      const expirationTime = new Date().getTime() + 30 * 24 * 60 * 60 * 1000; // 30 days
      localStorage.setItem("token", token);
      localStorage.setItem("expires", expirationTime); // Set expiration time
      dispatch(setUser(userdetails));
    } catch (err) {
      console.error(err);
      toast.error("Login failed! Please check your credentials."); // Show error toast
    }
  };

  const location = useLocation();
  const from = location.state?.from || null;

  useEffect(() => {
    if (userrole) {
      // Redirect to original path if available, else default
      if (from) {
        navigate(from, { replace: true });
      } else if (userrole === "student") {
        navigate("/student", { replace: true });
      } else if (userrole === "admin" || userrole === "superadmin") {
        navigate("/admin", { replace: true });
      }
    }
  }, [userrole]);

  // Show forget password modal
  if (showForgetPassword) {
    return (
      <ForgetPassword
        onClose={() => setShowForgetPassword(false)}
        onBack={() => setShowForgetPassword(false)}
      />
    );
  }

  return (
    <>
      <div className="flex items-center justify-center h-[100vh]">
        <div className="flex items-center justify-center border-solid border-2 border-gray-200 shadow-lg">
          {/* Left Side (Image/Illustration) */}
          <div className="hidden md:flex md:w-1/2 h-full bg-yellow-200 justify-center items-center">
            <img className="w-full h-full shadow-lg" src={leftimg} alt="" />
          </div>

          {/* Right Side (Login Form) */}
          <div className="flex flex-col justify-center items-center md:w-1/2 w-full px-6 py-8">
            <div className="max-w-md w-full">
              <div className="flex justify-center mb-6">
                <img src={logo} alt="Logo" className="w-40 h-auto" />
              </div>

              <h2 className="text-center text-3xl font-bold text-gray-800">
                Welcome back 👋
              </h2>
              <p className="text-center text-gray-500 mb-8">
                Enter your credentials to access your account
              </p>

              <form className="space-y-4">
                <div>
                  <input
                    name="email"
                    type="email"
                    placeholder="Email ID"
                    className="mt-1 px-3 py-2 border border-gray-300 w-full focus:outline-none focus:border-indigo-500"
                    onChange={handeChangeInput}
                    value={form.email}
                  />
                </div>

                <div>
                  <input
                    name="password"
                    type="password"
                    placeholder="Password"
                    className="px-3 py-2 border border-gray-300 w-full focus:outline-none focus:border-indigo-500"
                    onChange={handeChangeInput}
                    value={form.password}
                  />
                </div>

                <div className="flex justify-end">
                  <button
                    type="button"
                    className="text-sm text-indigo-600 hover:text-indigo-500"
                    onClick={() => setShowForgetPassword(true)}
                  >
                    Forgot Password?
                  </button>
                </div>

                <div>
                  <button
                    type="submit"
                    className="w-[150px] bg-indigo-600 text-white flex mx-auto justify-center align-center py-2 px-4 hover:bg-indigo-700 focus:outline-none"
                    onClick={submitForm}
                  >
                    Login
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
